(function () {
  const track = document.getElementById('fp-track');
  const slides = Array.from(track.querySelectorAll('.fp-slide'));
  const dotsContainer = document.getElementById('fp-dots');
  const slider = document.getElementById('fp-slider');
  const AUTO_DELAY = 5000;

  // 👉 Détection RTL
  const isRTL = document.documentElement.lang.startsWith("ar");

  let current = 0;
  let isPaused = false;
  let progressStartTime = 0;
  let progressRemaining = AUTO_DELAY;
  let rafId = null;

  // --- Création des dots ---
  function buildDots() {
    dotsContainer.innerHTML = '';
    slides.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.className = 'fp-dot';
      btn.type = 'button';
      btn.setAttribute('aria-label', `Aller à la slide ${i + 1}`);

      const prog = document.createElement('span');
      prog.className = 'progress';
      btn.appendChild(prog);

      btn.addEventListener('click', () => {
        goTo(i);
      });

      dotsContainer.appendChild(btn);
    });
  }

  // --- Mise à jour des dots ---
  function updateDots() {
    const dots = dotsContainer.querySelectorAll('.fp-dot');
    dots.forEach((dot, i) => {
      const prog = dot.querySelector('.progress');
      dot.classList.toggle('animating', i === current);
      prog.style.width = i === current ? '0%' : '0%';
    });
    progressStartTime = performance.now();
    progressRemaining = AUTO_DELAY;
    animateProgress();
  }

  // --- Animation barre ---
  function animateProgress() {
    cancelAnimationFrame(rafId);
    const prog = dotsContainer.querySelector('.fp-dot.animating .progress');
    if (!prog) return;

    function step() {
      if (!isPaused) {
        const elapsed = performance.now() - progressStartTime;
        const percent = Math.min((elapsed / progressRemaining) * 100, 100);
        prog.style.width = percent + '%';

        if (elapsed >= progressRemaining) {
          next();
          return;
        }
      }
      rafId = requestAnimationFrame(step);
    }
    rafId = requestAnimationFrame(step);
  }

  // --- Aller à une slide (RTL FIX ICI) ---
  function goTo(index) {
    if (!slides.length) return;

    current = (index + slides.length) % slides.length;

    const translateValue = current * 100;
    const direction = isRTL ? 1 : -1; // 🔥 inversion ici

    track.style.transform = `translateX(${direction * translateValue}%)`;

    updateDots();
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function resetAuto() {
    progressStartTime = performance.now();
    progressRemaining = AUTO_DELAY;
    animateProgress();
  }

  // --- Pause hover ---
  slider.addEventListener('mouseenter', () => { isPaused = true; });
  slider.addEventListener('mouseleave', () => {
    isPaused = false;
    progressStartTime = performance.now();
  });

  // --- Swipe mobile ---
  let startX = 0, deltaX = 0;
  let ignoreSwipe = false;

  slider.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
    ignoreSwipe = false;

    let el = e.target;
    while (el && el !== slider) {
      if (el.classList && el.classList.contains('fp-buttons')) {
        ignoreSwipe = true;
        break;
      }
      el = el.parentElement;
    }
  }, { passive: true });

  slider.addEventListener('touchmove', e => {
    deltaX = e.touches[0].clientX - startX;
  }, { passive: true });

  slider.addEventListener('touchend', () => {
    if (!ignoreSwipe && Math.abs(deltaX) > 50) {
      deltaX > 0 ? prev() : next();
    }
    deltaX = 0;
    resetAuto();
  });

  // --- Init ---
  buildDots();
  goTo(0);
})();